import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "wrap", "column", "align", "children"];
import React, { forwardRef } from 'react';
import Box from 'components/Box';
var Flex = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    wrap = _ref.wrap,
    column = _ref.column,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: as || 'div',
    display: "flex",
    wrapItems: wrap,
    stackItems: column,
    alignItems: align
  }, otherProps), children);
});
Flex.displayName = 'Flex';
export { Box };
export default Flex;